var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSumo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2D9CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1593 5.10975C12.0741 7.11562 12.5601 7.47 13.0253 7.59769C11.4081 7.39519 10.4957 7.28044 8.97187 6.48056L8.01 7.59994L14.0625 8.94375C12.1691 10.5536 11.349 11.4114 10.1593 12.8891H7.86937C6.86306 11.4165 6.192 10.9384 4.89938 10.3427C6.6195 10.5013 7.57575 10.6071 8.97187 11.4339L10.0187 10.2583L3.9375 8.94375C5.35162 7.77825 6.17456 7.00087 7.86881 5.10975H10.1593ZM8.01 4.83019C8.53312 4.18612 8.74687 3.87281 9.02812 3.375C9.30375 3.888 9.51694 4.20469 10.0181 4.83019H8.01ZM10.0181 13.1698C9.49444 13.8139 9.28013 14.1272 9 14.625C8.72437 14.112 8.51062 13.7953 8.01 13.1698H10.0181Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumo);
export default __webpack_public_path__ + "static/media/sumo.d86a3accc3f0b2d96b4c9001b1e8ec83.svg";
export { ForwardRef as ReactComponent };